// src/services/refundService.js
import { apiRequest } from './api';

export const refundService = {
    /**
     * Calculate potential refund amount without creating a request
     */
    calculateRefund: async () => {
        try {
            const response = await apiRequest.get('/subscriptions/calculate-refund');
            return response.data.data || response.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to calculate refund');
        }
    },

    /**
     * Request a refund for current subscription
     */
    requestRefund: async (reason) => {
        try {
            const response = await apiRequest.post('/subscriptions/request-refund', { reason });
            return response.data.data || response.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to request refund');
        }
    },

    /**
     * Get all refund requests (admin can see all, users see their own)
     */
    getRefundRequests: async (status = null) => {
        try {
            const params = {};
            if (status) params.status = status;

            const response = await apiRequest.get('/refunds', { params });
            return response.data.data || response.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch refund requests');
        }
    },

    /**
     * Process refund request (Admin only)
     */
    processRefund: async (refundId, status, notes = '', refundMethod = 'bank_transfer', refundReference = null) => {
        try {
            const response = await apiRequest.post('/refunds/process', {
                refund_id: refundId,
                status,
                notes,
                refund_method: refundMethod,
                refund_reference: refundReference
            });
            return response.data.data || response.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to process refund');
        }
    }
};

export default refundService;
